// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"823f86c9","198":"662e3d92","276":"612b3a00","420":"31cf1bfe","439":"0ca87bbc","453":"0245fc84","473":"f1e342d1","482":"cd47835e","610":"e5c23be8","636":"81a5a50b","662":"732cbb49","710":"7d42b500","747":"b3606f68","877":"30c390b8","895":"babdccfa"}[chunkId] + ".chunk.js";
};